class DomainEventDispatcher {
  constructor() {
    this.handlers = {};
  }

  register(eventName, handler) {
    if (!this.handlers[eventName]) {
      this.handlers[eventName] = [];
    }

    this.handlers[eventName].push(handler);
  }

  async dispatch(event) {
    const handlers = this.handlers[event.constructor.name] || [];

    for (const handler of handlers) {
      await handler(event);
    }
  }
}

export const domainEventDispatcher = new DomainEventDispatcher();